import { module } from "../modular/modular";
import { gsap } from 'gsap';
import { SplitText } from "../libs/gsap/SplitText";

gsap.registerPlugin(SplitText);

export default class extends module {
    constructor(m) {
        super(m);

		this.events = {
			mouseenter: {
				wrap: 'hover'
			}
		}


		this.needOnMobile = true;

		if(typeof this.getData('desktop') == 'string') {
			this.needOnMobile = false;
		}

		this.auto = typeof this.getData('auto') == 'string';

		this.delay = typeof this.getData('delay') == 'string' ? parseFloat(this.getData('delay')) : 0;
		this.stagger = typeof this.getData('stagger') == 'string' ? parseFloat(this.getData('stagger')) : 0.2;
		this.duration = typeof this.getData('duration') == 'string' ? parseFloat(this.getData('duration')) : 1;
		this.iteration = typeof this.getData('iteration') == 'string' ? parseFloat(this.getData('iteration')) : 1;
    }

    init() {


		if(window.isMobile && !this.needOnMobile) {
			return;
		}
		if(window.isAndroid) return;

		this.split = new SplitText(this.el, {
			type: 'chars, words'
		});
		this.hide(0,0);

    }

	ready() {
		if(window.isMobile && !this.needOnMobile) {
			return;
		}
		if(window.isAndroid) return;

		if(this.auto) {
			this.display(this.delay, this.duration, this.stagger, this.iteration);
			gsap.delayedCall(this.delay, () => {
				this.el.classList.add('is-inview');
			});
		}
	}

	toggle(e) {
		if(window.isMobile && !this.needOnMobile) {
			return;
		}
		if(window.isAndroid) return;

		if(e.mode == 'enter') {
			this.display(this.delay, this.duration, this.stagger, this.iteration);
		} else {
			this.hide();
		}
	}

	display(delay = 0, duration = 0.1, stagger = 0.2, iteration = 1) {
		if(window.isMobile && !this.needOnMobile) {
			return;
		}
		if(window.isAndroid) return;

		if(this.split == undefined) {
			return;
		}

		if(this.tl != undefined) {
			this.tl.kill();
		}
		this.tl = gsap.timeline();

		for (let index = 0; index < iteration; index++) {

			this.tl.to(this.split.chars, {
				alpha: index % 2 == 0 ? 1 : 0,
				duration: duration / iteration,
				delay: index == 0 ? delay : 0,
				ease: "power2.out",
				stagger: {
					amount: stagger,
					from: "random"
				}
			});
		}
	}

	hide(delay = 0, duration = 0.1) {
		if(window.isMobile && !this.needOnMobile) {
			return;
		}
		if(window.isAndroid) return;

		if(this.split == undefined) {
			return;
		}

		if(this.tl != undefined) {
			this.tl.kill();
		}
		this.tl = gsap.timeline();
		
		this.tl.to(this.split.chars, {
			alpha: 0.001,
			duration,
			delay,
			ease: "power2.in",
			stagger: {
				amount: 0.05,
				from: "random"
			}
		});
	}

	destroy() {
		if(window.isMobile && !this.needOnMobile) {
			return;
		}
		if(window.isAndroid) return;
		
		if(this.tl != undefined) {
			this.tl.kill();
		}
	}

}
